import React from 'react';

/**
 * MUI Components
 */
import {
    Autocomplete,
    TextField,
    CircularProgress,
    Chip
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';

const UserSelector = ({ users, loading, value, onChange }) => {
    const { t } = useTranslation();

    const normalizeString = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    const optionLabel = (option) => {

        let label = option.name;

        if (option.sname) {
            // if name and sname are the same, don't show both
            if (option.name != option.sname) {
                label = `${option.sname} (${option.name})`;
            }
        }

        if (option.scategory) {
            label = `${label} (${option.scategory})`;
        }

        return label;
    };

    const filterOptions = createFilterOptions({
        stringify: (option) => normalizeString(optionLabel(option)),
        trim: true,
    });

    const handleChange = (event, newValue) => {
        onChange(newValue);
    };

    const isOptionEqualToValue = (option, value) => {
        return option.id === value.id;
    };

    return (
        <Autocomplete
            multiple
            options={users}
            value={value}
            onChange={handleChange}
            getOptionLabel={optionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            loading={loading}
            filterOptions={filterOptions}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t('Recipients')}
                    placeholder={t('Select recipients')}
                    margin="normal"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip label={option.name} {...getTagProps({ index })} key={option.id} />
                ))
            }
        />
    );
};

export default UserSelector;
